module.exports = __webpack_public_path__ + "static/media/btn_point_yright_nor.de0ea546.svg";